import { render } from "./ActivityTemplateLink.vue?vue&type=template&id=f1b48b5c"
import script from "./ActivityTemplateLink.vue?vue&type=script&lang=js"
export * from "./ActivityTemplateLink.vue?vue&type=script&lang=js"

import "./ActivityTemplateLink.vue?vue&type=style&index=0&id=f1b48b5c&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__